
    import { defineComponent } from 'vue'
    import Listbox from 'primevue/listbox'
    import Message from 'primevue/message'
    import workspaceFederationDatasetListDescriptor from './WorkspaceFederationDatasetListDescriptor.json'

    export default defineComponent({
        name: 'workspace-federation-dataset-list',
        components: {
            Listbox,
            Message
        },
        props: { mode: { type: String }, propDatasets: { type: Array } },
        emits: ['showInfo', 'datasetSelected'],
        data() {
            return {
                workspaceFederationDatasetListDescriptor,
                dataset: [] as any[]
            }
        },
        watch: {
            propDatasets() {
                this.loadDatasets()
            }
        },
        created() {
            this.loadDatasets()
        },
        methods: {
            loadDatasets() {
                this.dataset = this.propDatasets as any[]
            },
            selectDataset(dataset: any) {
                this.$emit('datasetSelected', { dataset: dataset, mode: this.mode })
            }
        }
    })
